import React from 'react';
import classNames from 'clsx';
import { useSelector } from 'react-redux';
import { getFormValues } from 'redux-form';

import { DefaultFormFooterProps } from './DefaultFormFooter.interface';
import { useStyles } from './DefaultFormFooter.styles';
import { selectIsPaymentMethodOnInstallmentsActive } from 'app/store/data/quotationResult';
import { selectQuotation } from 'app/store/data/quotation';
import { FormsEnum, LabelEnum } from 'app/shared/enums';
import { RootState } from 'app/store/rootReducer';
import { CheckoutFormByKeysInterface } from 'app/shared/interfaces/CheckoutForm.interface';
import { getFormattedDate } from 'app/services/dates.service';

export default function DefaultFormFooter({
  children,
  isPaymentView = false,
}: DefaultFormFooterProps) {
  const classes = useStyles();
  const isPaymentMethodOnInstallmentsActive = useSelector(
    selectIsPaymentMethodOnInstallmentsActive
  );
  const quotation = useSelector(selectQuotation);
  const formValues = useSelector(
    (state: RootState) =>
      getFormValues(FormsEnum.CheckoutPaymentForm)(state) as
        | CheckoutFormByKeysInterface
        | undefined
  );
  const emailAddress = formValues?.emailAddress || quotation?.emailAddress;
  const formattedStartDate = quotation?.startDate
    ? getFormattedDate(quotation.startDate as string)
    : '';
  const shouldShowPaymentInfo = !!(
    isPaymentView &&
    isPaymentMethodOnInstallmentsActive &&
    emailAddress &&
    formattedStartDate
  );
  const isNewPaymentFooterStyleActive =
    isPaymentView && isPaymentMethodOnInstallmentsActive;

  return (
    <>
      <div
        className={classNames(classes.footer, {
          [classes.newStyleFooter]: isNewPaymentFooterStyleActive,
        })}
      >
        {children}
      </div>
      {shouldShowPaymentInfo && (
        <div
          className={classNames(classes.paymentInfoWrapper, {
            [classes.newStyleFooter]: isNewPaymentFooterStyleActive,
          })}
        >
          <div className={classes.paymentInfo}>
            <div>
              {LabelEnum.DocumentsAndPaymentLinkWillBeSentToEmail}
              {emailAddress}
            </div>
            <div>
              {LabelEnum.ProtectionStartsOn}
              {formattedStartDate}
              {LabelEnum.ProtectionStartsOnAfterPaymentSuffix}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
